import React, { useEffect, useContext, useRef } from "react";
import Header from "../Components/Header/Header";
import Banner from "../Components/Banner/Banner";
import Posts from "../Components/Posts/Posts";
import Footer from "../Components/Footer/Footer";
import { AuthContext } from "../contextStore/AuthContext";
import client from "../api/client"; // axios instance for backend API

/**
 * Home page: light defensive auth check
 *
 * Fixes:
 * - Removed double /api prefix in API call (was causing /api/auth/me 404).
 * - Keeps token validation and context sync logic intact.
 */

function Home() {
  const { token, setUser } = useContext(AuthContext);
  const cancelledRef = useRef(false);

  useEffect(() => {
    cancelledRef.current = false;

    async function checkAuth() {
      if (!token || typeof token !== "string") return;

      const t = token.trim();
      if (t === "" || t === "null" || t === "undefined" || t.length < 20) {
        console.warn("Home: token looks invalid/bogus, skipping auth check", t);
        return;
      }

      try {
        // ✅ FIX: removed extra `/api` — client baseURL already includes `/api`
        const res = await client.get("/auth/me", {
          headers: { Authorization: `Bearer ${t}` },
        });

        if (cancelledRef.current) return;

        if (res?.data?.ok && res.data.user) {
          setUser(res.data.user, token);
          try {
            localStorage.setItem("user", JSON.stringify(res.data.user));
          } catch (e) {
            console.warn("Home: could not persist user to localStorage", e);
          }
        } else {
          console.warn("Home: unexpected auth/me response", res?.data);
        }
      } catch (err) {
        if (cancelledRef.current) return;
        const status = err?.response?.status;
        if (status === 401) {
          console.warn("Home: /auth/me returned 401 — clearing auth");
          setUser(null, null);
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        } else {
          console.warn("Home: auth check failed (non-401)", err);
        }
      }
    }

    checkAuth();

    return () => {
      cancelledRef.current = true;
    };
  }, [token, setUser]);

  return (
    <div className="homeParentDiv">
      <Header />
      <Banner />
      <Posts />
      <Footer />
    </div>
  );
}

export default Home;
